import axios from 'axios';
import config from '../config';


export const axiosObj = axios.create({
    baseURL: config.BASE_URL,
    withCredentials: true, // to send the cookies info 
})